module.exports = __webpack_public_path__ + "static/flags/BD-898ebfedf2dce89f02a88e3c07e32f6d.gif";